<template>
  <p :style="style">
    <strong v-if="customText">{{ customText }}</strong>
    <strong v-else>
      <span class="material-icons">local_offer</span> {{ bovine.earring }} -
      {{ bovine?.type?.name || '-' }}
    </strong>
  </p>
</template>

<script>
import { bovineColors as colors } from '../lib/bovines';

export default {
  name: 'BovineTag',
  props: {
    bovine: {
      type: Object,
      required: true,
    },
    small: Boolean,
    inactive: Boolean,
    customText: String,
  },
  computed: {
    style() {
      return {
        fontSize: this.small && '0.85rem',
        width: 'fit-content',
        heigth: '10px',
        color: 'white',
        textAlign: 'center',
        borderRadius: '3px',
        padding: '3px 8px',
        ...(this.inactive ? { filter: 'grayscale(100%)' } : {}),
        ...(colors[this.bovine.type?.id] || {}),
      };
    },
  },
};
</script>

<style scoped>
.material-icons {
  font-size: 18px;
  vertical-align: top;
  padding-top: 1px;
}
</style>
